<template>
  <Header>
    <div>
      <el-menu
        :default-active="activeIndex"
        background-color="#003366"
        text-color="#fff"
        active-text-color="#ffd04b"
        mode="horizontal"
        :class="UI.isMobile ? 'mobile-header-menu' : 'header-menu'"
        @select="handleSelect"
      >
        <el-menu-item index="home">首页</el-menu-item>
        <el-menu-item index="games">赛事</el-menu-item>
        <el-menu-item index="players">运动员</el-menu-item>
        <el-menu-item index="newsList">新闻公告</el-menu-item>
        <el-menu-item index="filesDownload">文件下载</el-menu-item>
      </el-menu>
    </div>
  </Header>
</template>

<script>
import { mapState } from 'vuex';
import Header from '@/components/header.vue';

export default {
  components: {
    Header,
  },

  computed: {
    ...mapState(['UI']),
  },

  data() {
    return {
      activeIndex: '',
    };
  },

  watch: {
    // 如果路由有变化，会再次执行该方法
    $route: 'routeChange',
  },

  mounted() {
    this.routeChange();
  },

  methods: {
    routeChange: function() {
      if (this.activeIndex != this.$route.name)
        this.activeIndex = this.$route.name;
    },

    handleSelect: function(key, keyPath) {
      if (key) {
        this.$router.replace({ name: key });
      }
    },
  },
};
</script>

<style lang="scss">
.header-menu {
  height: 70px;

  li.el-menu-item {
    height: 100%;
    font-weight: 600;
    font-size: 16px;
    text-align: center;
    display: flex;
    align-items: center;
  }

  &.el-menu--horizontal {
    border-bottom: none;
  }

  .el-submenu {
    height: 100%;

    text-align: center;
    display: flex;
    align-items: center;

    .el-submenu__title {
      font-weight: 600;
      font-size: 16px;
      height: 70px;
      line-height: 70px;
    }
  }
}

.mobile-header-menu {
  .el-menu-item {
    text-align: center;
    display: flex;
    align-items: center;
    width: 100%;
  }

  &.el-menu--horizontal {
    border-bottom: none;
    width: 100%;
  }

  .el-menu-item.is-active {
    border-bottom: 1px solid #ffd04b;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/menuHeader.vue